(function () {
    // Initialize your script here
    var initializeMarqueeBlock = function (block) {

           var itemWidth;

           var marqueeContentList = block.querySelector('.dvrw-marquee-section__list');

           var handleResize = () => {
               itemWidth = marqueeContentList.firstElementChild.offsetWidth;
           };
           handleResize();
           window.addEventListener('resize', handleResize);
           var translateX = 0;
           var updateTranslateX = () => {
               translateX = translateX <= -itemWidth ? 0 : translateX - 2;
               marqueeContentList.style.transform = `translate3d(${translateX}px, 0, 0)`;
           };

           var interval = setInterval(updateTranslateX, 1000 / 40); // Adjusted to 60 frames per second

           var cleanup = () => {
               clearInterval(interval);
               window.removeEventListener('resize', handleResize);
           };
       };

       document.addEventListener('DOMContentLoaded', function() {
           var marqueeBlocks = document.querySelectorAll('.dvrw-marquee-section');
           if(marqueeBlocks.length){
            marqueeBlocks.forEach(function (block) {
                initializeMarqueeBlock(block);
            });
           };
       });
   })();
